import { createFileRoute, redirect } from '@tanstack/react-router';
import { CUSTOMER_DATA_TABS } from 'cpool-constants';

import { CustomerData } from '~/features/leadDetails/components/Overview/CustomerData';
import { CUSTOMER_DATA_TAB_PATHS } from '~/features/leadDetails/constants/tabPaths';
import { isCustomerDataTabPath } from '~/features/leadDetails/utils/tabPaths';

export const Route = createFileRoute('/_app/leads_/details/$leadId/customer-data/$customerTab')({
    beforeLoad: ({ params }) => {
        if (!isCustomerDataTabPath(params.customerTab)) {
            throw redirect({
                params: {
                    customerTab: CUSTOMER_DATA_TAB_PATHS[CUSTOMER_DATA_TABS.PERSONAL_DATA],
                    leadId: params.leadId,
                },
                replace: true,
                search: true,
                to: '/leads/details/$leadId/customer-data/$customerTab',
            });
        }
    },
    component: CustomerData,
});
